import(/* webpackMode: "eager", webpackExports: ["BadgeProvider","useBadgeContext","useBadgeValue"] */ "/vercel/path0/node_modules/@veiag/payload-enhanced-sidebar/dist/components/EnhancedSidebar/BadgeProvider/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["useEnhancedSidebar"] */ "/vercel/path0/node_modules/@veiag/payload-enhanced-sidebar/dist/components/EnhancedSidebar/context.js");
;
import(/* webpackMode: "eager", webpackExports: ["useNavItemState"] */ "/vercel/path0/node_modules/@veiag/payload-enhanced-sidebar/dist/components/EnhancedSidebar/hooks/useNavItemState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTabState"] */ "/vercel/path0/node_modules/@veiag/payload-enhanced-sidebar/dist/components/EnhancedSidebar/hooks/useTabState.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["EventMemberDetails"] */ "/vercel/path0/src/app/(marketing)/events/[id]/event-member-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventStatusBadge"] */ "/vercel/path0/src/app/(marketing)/events/[id]/event-status-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventVolunteerCTA"] */ "/vercel/path0/src/app/(marketing)/events/[id]/event-volunteer-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionCard"] */ "/vercel/path0/src/components/ui/section-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/payload/blocks/auth/auth-form-lexical.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventCarouselClient"] */ "/vercel/path0/src/payload/blocks/event-carousel/event-carousel-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/payload/blocks/state-picker/state-picker-lexical.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StateVariableClient"] */ "/vercel/path0/src/payload/blocks/state-variable/state-variable.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TalentCarouselClient"] */ "/vercel/path0/src/payload/blocks/talent-carousel/talent-carousel-client.tsx");
